export default "__VITE_ASSET__BjVyaeWw__"